var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 9.625C12.8334 10.8907 10.7814 11.9167 8.25008 11.9167C5.71878 11.9167 3.66675 10.8907 3.66675 9.625M12.8334 9.625C12.8334 8.35935 10.7814 7.33333 8.25008 7.33333C5.71878 7.33333 3.66675 8.35935 3.66675 9.625M12.8334 9.625V13.2917M3.66675 9.625V13.2917M18.3334 5.04167C18.3334 3.77601 16.2814 2.75 13.7501 2.75C11.9359 2.75 10.3679 3.27702 9.62508 4.04155M18.3334 5.04167C18.3334 5.88991 17.4117 6.63051 16.0417 7.02675M18.3334 5.04167V12.8333C18.3334 13.5119 17.4117 14.1044 16.0417 14.4214M18.3334 9.16667C18.3334 9.8603 17.3704 10.464 15.95 10.7754M12.8334 13.2917C12.8334 14.5573 10.7814 15.5833 8.25008 15.5833C5.71878 15.5833 3.66675 14.5573 3.66675 13.2917M12.8334 13.2917V16.9583C12.8334 18.224 10.7814 19.25 8.25008 19.25C5.71878 19.25 3.66675 18.224 3.66675 16.9583V13.2917",
    stroke: "#080b2a",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.d23310db865ab4b2207c2c4557663b20.svg";
export { ForwardRef as ReactComponent };